export const regexNumber = /\D/g;
export const regexFloat = /\D\?.?\D*$/g;
